import DashboardLayout from '../Layouts/DashboardLayout';
import PaymentSuccessComp from './PaymentSuccessComp';
const PaymentSuccessContainer = () => {
  return (
    <DashboardLayout>
      <PaymentSuccessComp></PaymentSuccessComp>
    </DashboardLayout>
  );
};
export default PaymentSuccessContainer;